import type { FC } from 'react'

import type { TeamMember } from '@api'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Tooltip } from '@/components/ui/tooltip'

import { TeamAvatar } from '../../team-avatar'

interface Props {
  members: TeamMember[]
  limit?: number
}

export const TeamAvatars: FC<Props> = ({ members, limit = 3 }) => {
  const usersToShow = members.slice(0, limit)

  return (
    <div className="flex items-center -space-x-2 ">
      {usersToShow.map((member) => (
        <div
          className="flex items-center gap-3"
          key={member.id}
        >
          <div className="relative">
            <Tooltip content={member.name || 'Unknown'}>
              <TeamAvatar
                name={member.name || 'Unknown'}
                avatarSrc={member.profilePicture}
                className="ring-text-default hover:ring-primary-200 h-6 w-6 text-xs ring-1"
              />
            </Tooltip>
          </div>
        </div>
      ))}
      {members.length > limit && (
        <Popover>
          <PopoverTrigger className="z-10">
            <span className="text-neutral-default flex h-7 min-w-7 items-center justify-center rounded-full bg-gray-600 p-1 text-xs ring-1 ring-white">
              {members.length > limit && `+${members.length - limit}`}
            </span>
          </PopoverTrigger>
          <PopoverContent className="max-h-[200px] min-w-fit overflow-y-auto overflow-x-hidden">
            <ul className="divide-border divide-y-2">
              {members.slice(limit).map((member) => (
                <li
                  className="flex items-center justify-between gap-x-6 py-1"
                  key={member.id}
                >
                  <TeamAvatar
                    name={member.name || 'Unknown'}
                    avatarSrc={member.profilePicture}
                    className="h-7 w-7 shrink-0"
                  />
                  <div className="min-w-0 flex-auto">
                    <p className="text-text-default text-sm font-semibold leading-6">
                      {member.name || 'Unknown'}
                    </p>
                    <p className="text-xs font-semibold leading-6 text-gray-400">
                      {member.email}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </PopoverContent>
        </Popover>
      )}
    </div>
  )
}
